















import Vue from 'vue'
import api from '@/api'
import { Portfolio } from '../types'

export default Vue.extend({
  name: 'AdminPortfolioList',

  data: () => ({
    portfolios: [] as Array<Portfolio>,
  }),

  methods: {
    addPortfolio() {
      this.$router.push({ name: 'AdminPortfolio', params: { id: 'new' } })
    },
  },

  async mounted() {
    this.portfolios = await api.getPortfolios()
  },
})
